import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { Space, TextField } from "@pankod/refine-antd";
import { FC } from "react";

export const EligibilityTag: FC<{ value: boolean }> = ({ value }) => (
  <Space direction="horizontal">
    {value ? (
      <CheckOutlined style={{ color: "green" }} />
    ) : (
      <CloseOutlined style={{ color: "red" }} />
    )}
    <TextField value={value ? "Sim" : "Não"} />
  </Space>
);
